import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'
import {
  TituloHeader, Body, NavBar, ImagemHeader, SpanTitulo, SpanMenu, MenuItens, LinkTitulo,
} from '../UtilsEstilo'
import { fazerLogoff } from '../Funcoes'

const Padrao = ({ pagina, firebase }) => {
  const history = useHistory()

  return (
    <div>
      <NavBar>
        <SpanTitulo>
          <ImagemHeader src="./images/logo.svg" alt="daily-food" />
          <TituloHeader>Daily Food</TituloHeader>
        </SpanTitulo>
        <SpanMenu>
          <LinkTitulo to="/"><MenuItens>Meu Diário</MenuItens></LinkTitulo>
          <MenuItens onClick={() => fazerLogoff(firebase, history)}>Sair</MenuItens>
        </SpanMenu>
      </NavBar>
      <Body>
        {pagina}
      </Body>
    </div>
  )
}

Padrao.propTypes = {
  pagina: PropTypes.element,
  firebase: PropTypes.objectOf(PropTypes.any),
}

Padrao.defaultProps = {
  pagina: undefined,
  firebase: undefined,
}

export default Padrao
